// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-7Y0T","label":"styles_label__1Fwal"};